// V12 (rà soát người dùng 05/10/2026): Nhật ký hệ thống hiện mã hành động ("tro_ly_vong.chay_thu", "bot.pair") và chi tiết dạng mã
// ("jobId=… · kichBan=fsfee6yz6q") — Super đọc không được. Ở đây: tên hành động tiếng Việt + nhãn tiếng Việt cho từng trường chi tiết,
// mã kịch bản / bot / tài khoản / lệnh đổi ra TÊN (máy chủ tra: GET /api/audit/ten). Mã gốc vẫn giữ ở title để tra cứu khi cần.
// Thuần (không DOM) để kiểm bằng unit test: mọi mã hành động máy chủ ghi đều phải có tên tiếng Việt.

export const TEN_HANH_DONG: Record<string, string> = {
  login: "Đăng nhập",
  logout: "Đăng xuất",
  "user.create": "Tạo tài khoản",
  "user.patch": "Sửa tài khoản",
  "totp.on": "Bật xác thực 2 lớp",
  "totp.off": "Tắt xác thực 2 lớp",
  "totp.enable": "Tạo khoá xác thực 2 lớp",
  "bot.pair": "Ghép cặp bot",
  "bot.pair-code": "Lấy mã ghép cặp bot",
  "bot.patch": "Sửa bot",
  "bot.ghi-chu": "Sửa ghi chú bot",
  "plugin.sao-luu": "Bot sao lưu dữ liệu plugin lên Boss",
  "plugin.sao-luu.chep": "Chép bản sao lưu plugin từ bot khác",
  "bot.delete": "Gỡ bot",
  "bot.req": "Gửi yêu cầu tới bot",
  "bot.transfer": "Chuyển bot sang Boss khác",
  "bundle.copy": "Chép kịch bản trong kho",
  "bundle.gom": "Gom kịch bản từ bot về kho",
  "bundle.gom.failed": "Gom kịch bản từ bot lỗi",
  "bundle.pull": "Lấy kịch bản từ bot lên kho",
  "bundle.pull.same": "Lấy kịch bản từ bot (đã có sẵn)",
  "bundle.push": "Gửi kịch bản xuống bot",
  "bundle.push.failed": "Gửi kịch bản xuống bot lỗi",
  "bundle.push.plugin_cu": "Bot dùng plugin cũ, chưa gửi kịch bản",
  "bundle.push.queued": "Xếp hàng gửi kịch bản xuống bot",
  "bundle.push_all": "Gửi kịch bản xuống mọi bot",
  "job.create": "Ra lệnh chạy",
  "job.draft": "Soạn lệnh bằng chữ",
  "job.cancel": "Huỷ lệnh",
  "job.canary-continue": "Cho chạy tiếp sau bot thử",
  "run.approve": "Duyệt bước chờ duyệt",
  "run.reject": "Bỏ bước chờ duyệt",
  "run.stop": "Dừng lần chạy",
  "run.otp": "Nhập mã OTP cho bot",
  "stop-all": "DỪNG TẤT CẢ bot",
  "schedule.create": "Tạo lịch",
  "schedule.update": "Sửa lịch",
  "schedule.delete": "Xoá lịch",
  "schedule.fire": "Lịch tự phát lệnh",
  "schedule.skip": "Lịch bỏ qua một lần",
  "notify.config": "Sửa cài đặt thông báo Telegram/Email",
  "notify.test": "Gửi thử thông báo Telegram/Email",
  "notify.failed": "Gửi thông báo Telegram/Email lỗi",
  "model.set": "Sửa mô hình AI",
  "model.clear": "Xoá cấu hình mô hình AI",
  "model.seed": "Nạp cấu hình mô hình AI ban đầu",
  "model.quota": "Bot chạm hạn mức gọi AI",
  "model.tai_khoan": "Tài khoản AI lỗi (hết tiền / khoá sai)",
  "compare.group.set": "Sửa nhóm so sánh",
  "compare.group.delete": "Xoá nhóm so sánh",
  "compare.report.send": "Gửi báo cáo So sánh Boss",
  "warn.config": "Sửa cài đặt cảnh báo người làm kém",
  "warn.send": "Gửi cảnh báo người làm kém",
  "announce.send": "Gửi thông báo",
  "announce.delete": "Thu hồi thông báo",
  "reply.config": "Sửa cài đặt tự trả lời bình luận",
  "reply.scan": "Tự trả lời: giao việc",
  "reply.skip": "Tự trả lời: bỏ qua",
  "hoidong.config": "Sửa cài đặt hội đồng nhiều nick",
  "hoidong.giao": "Hội đồng: giao nick vào bình luận",
  "hoidong.bai": "Hội đồng: nhiều nick vào một bài",
  "hoidong.skip": "Hội đồng: bỏ qua",
  "nhom_nick.cap_nhat": "Cập nhật nhóm của nick",
  "kich_ban.yeu_cau": "Nhờ AI viết kịch bản",
  "kich_ban.yeu_cau_nhieu_mang": "Nhờ AI viết kịch bản nhiều mạng",
  "chuoi.tao": "Tạo chuỗi kịch bản",
  "chuoi.sua": "Sửa chuỗi kịch bản",
  "chuoi.xoa": "Xoá chuỗi kịch bản",
  "chuoi.them": "Thêm kịch bản vào chuỗi",
  "chuoi.chay": "Chạy chuỗi kịch bản",
  "chuoi.dung": "Dừng chuỗi kịch bản",
  "kich_ban.tao": "Tạo kịch bản",
  "kich_ban.sua": "Sửa kịch bản",
  "kich_ban.sua_bang_loi": "Sửa kịch bản bằng lời",
  "kich_ban.sua_loi_ai": "AI sửa kịch bản lỗi",
  "kich_ban.ai_loi": "AI viết kịch bản lỗi",
  "kich_ban.doi_ten": "Đổi tên kịch bản",
  "kich_ban.nhan_ban": "Nhân bản kịch bản",
  "kich_ban.dat_nhan": "Đổi trạng thái kịch bản",
  "kich_ban.nhan_tu_doi": "Trạng thái kịch bản tự đổi",
  "kich_ban.nhap": "Chạy thử kịch bản",
  "kich_ban.nhap_nhieu": "Chạy thử kịch bản trên nhiều bot",
  "kich_ban.chay_that": "Chạy thật kịch bản",
  "kich_ban.chay_that_nhieu": "Chạy thật kịch bản trên nhiều bot",
  "kich_ban.cho_phep_chay_that": "Cho phép chạy thật kịch bản trên nhiều bot",
  "kich_ban.nhap_tep": "Nhập kịch bản từ tệp",
  "kich_ban.xuat": "Xuất kịch bản ra tệp",
  "kich_ban.xoa": "Xoá kịch bản (vào Thùng rác)",
  "kich_ban.khoi_phuc": "Khôi phục kịch bản từ Thùng rác",
  "kich_ban.xoa_vinh_vien": "Xoá vĩnh viễn kịch bản",
  "kich_ban.dong_bo_con": "Đồng bộ các đoạn (kịch bản con) của kịch bản nhiều mạng",
  "kich_ban.chuyen_kieu_cu": "Tự chuyển kịch bản dạng danh sách cũ sang sơ đồ (lúc khởi động)",
  "kich_ban.don_thung_rac": "Dọn Thùng rác (xoá vĩnh viễn mục quá 30 ngày)",
  "kich_ban.cap_nhat_kinh_nghiem": "Cập nhật kinh nghiệm vào kịch bản",
  "kb_mau.phat": "Phát hành kịch bản mẫu",
  "kb_mau.sua": "Sửa kịch bản mẫu",
  "kb_mau.thu_hoi": "Thu hồi kịch bản mẫu",
  "kb_mau.dung": "Dùng kịch bản mẫu",
  "kb_mau.cap_nhat_ban_rieng": "Cập nhật bản riêng từ kịch bản mẫu",
  "kb_mau.tao_san_pham": "Tạo sản phẩm từ kịch bản mẫu",
  "kb_mau.tu_cap_nhat": "Tự cập nhật các bản dùng theo kịch bản mẫu vừa sửa",
  // Kho mẫu (09–10/10/2026): thiếu tên tiếng Việt ở bảng này (test zz-ten-hanh-dong quét mọi mã audit trong mã nguồn, 11/10/2026)
  "kho_mau.tao": "Tạo kịch bản từ Kho mẫu",
  "kho_mau.cai_dat": "Đặt các ô cài đặt của kịch bản tạo từ Kho mẫu",
  "kho_mau.co_ban": "Sửa Cài đặt cơ bản của kịch bản tạo từ Kho mẫu",
  "kho_mau.quay_ve_mau": "Đưa kịch bản về đúng như kịch bản mẫu",
  "kho_mau.tu_cap_nhat": "Tự cập nhật kịch bản dùng mẫu theo bản mẫu mới",
  "kho_mau.tu_cap_nhat_loi": "Tự cập nhật kịch bản dùng mẫu không thành công",
  "kho_mau.chuyen_ban_cu": "Chuyển các bản dùng mẫu kiểu cũ sang Kho mẫu (lúc khởi động)",
  "kich_ban.tu_dong_mac_dinh": "Bật “Tự động” mặc định cho mọi ô rủi ro cao đã lưu (một lần, lúc khởi động)",
  "kho_anh.tai_len": "Tải ảnh lên kho ảnh",
  "kho_anh.sua": "Sửa ảnh trong kho ảnh",
  "kho_anh.xoa": "Xoá ảnh khỏi kho ảnh",
  "kho_video.tai_len": "Tải video lên kho video",
  "kho_video.sua": "Sửa mô tả video trong kho video",
  "kho_video.xoa": "Xoá video khỏi kho video",
  "kho_video.cap_phat": "Cấp video cho bot đăng",
  "kho_video.da_dang": "Bot báo đã đăng video",
  "kho_video.chua_xac_nhan": "Bot báo chưa xác nhận được bài video",
  "kho_video.loi": "Bot báo lỗi trước khi đăng video",
  "kho_video.huy": "Bot bỏ việc đăng video (chưa đăng)",
  "kho_video.xac_nhan_thu_cong": "Xác nhận thủ công video đã đăng",
  "kho_video.cho_phep_dang_lai": "Cho phép đăng lại video",
  "kho_video.dang_ngay": "Tạo việc đăng video thử",
  "kho_video.xoa_tep": "Xoá tệp video khỏi máy chủ (đã đăng xong)",
  "kho_video.xoa_tep_loi": "Chưa xoá được tệp video khỏi máy chủ (sẽ thử lại)",
  "kho_video.cai_dat": "Bật / tắt tự xoá tệp video sau khi đăng",
  "kho_video.don_ngay": "Dọn ngay tệp video thừa trên máy chủ",
  "kho_video.don": "Dọn tệp video thừa trên máy chủ",
  "kho_video.tai_len_lai": "Tải lên lại tệp video đã xoá",
  "san_pham.tao": "Tạo sản phẩm",
  "san_pham.nhap": "Nhập sản phẩm",
  "san_pham.sua": "Sửa sản phẩm",
  "san_pham.xoa": "Xoá sản phẩm",
  "san_pham.tom_tat": "AI tóm tắt sản phẩm",
  "sp_mau.phat": "Phát hành sản phẩm mẫu",
  "sp_mau.sua": "Sửa sản phẩm mẫu",
  "sp_mau.thu_hoi": "Thu hồi sản phẩm mẫu",
  "sp_mau.dung": "Dùng sản phẩm mẫu",
  "sp_mau.cap_nhat_ban_rieng": "Cập nhật bản riêng từ sản phẩm mẫu",
  "goi.dung": "Dùng gói seeding",
  "goi.sua": "Sửa gói seeding",
  "goi.xoa": "Xoá gói seeding",
  "goi.sua_kich_ban": "Gói seeding sửa kịch bản",
  "goi.ap_dung_ban_moi": "Áp dụng bản mới của gói seeding",
  "kinh_nghiem.day": "Dạy bài học",
  "kinh_nghiem.sua": "Sửa bài học",
  "kinh_nghiem.xoa": "Xoá bài học",
  "kinh_nghiem.hoc_ngay": "Học ngay từ lần chạy",
  "kinh_nghiem.chup": "Chụp bài học vào kịch bản",
  "kinh_nghiem.cap_nhat_kb": "Cập nhật bài học cho kịch bản",
  "kinh_nghiem.ai_bi_chan": "AI rút bài học bị chặn",
  "tro_ly.hoi": "Hỏi Trợ lý AI",
  "tro_ly.lam": "Trợ lý AI làm theo đề xuất",
  "tro_ly.bo_qua": "Bỏ đề xuất của Trợ lý AI",
  "tro_ly.ai_bi_chan": "Trợ lý AI bị chặn",
  "tro_ly_vong.bat_dau": "Trợ lý bắt đầu tự làm",
  "tro_ly_vong.chay_thu": "Trợ lý chạy thử kịch bản",
  "tro_ly_vong.sua": "Trợ lý sửa kịch bản",
  "tro_ly_vong.chan": "Trợ lý bị chặn",
  "tro_ly_vong.ket_thuc": "Trợ lý kết thúc tự làm",
  "dieu-khien.mo": "Mở điều khiển từ xa bot (Giải CAPTCHA)",
  "dieu-khien.dong": "Đóng điều khiển từ xa bot",
  "dieu-khien.tu-choi": "Điều khiển từ xa bot bị từ chối",
  "tu_sua.cai_dat": "Sửa cài đặt khi kịch bản lỗi",
  "tu_sua.che_do_kich_ban": "Đổi cách xử lý lỗi của kịch bản",
  "tu_sua.bat_dau": "AI bắt đầu tự sửa",
  "tu_sua.thu_sua": "AI thử sửa kịch bản",
  "tu_sua.ap_dung": "Áp dụng bản sửa",
  "tu_sua.tu_ap": "AI tự áp bản sửa",
  "tu_sua.hoan_tac": "Hoàn tác bản sửa",
  "tu_sua.duyet": "Duyệt bản sửa",
  "tu_sua.bo": "Bỏ bản sửa",
  "tu_sua.huy": "Huỷ tự sửa",
  "tu_sua.tam_dung": "Tạm dừng bot vì lỗi tài khoản",
  "tu_sua.bo_tam_dung": "Bỏ tạm dừng bot",
  "tu_sua.chay_tiep": "Chạy tiếp sau khi sửa",
  "ban_do.luu": "Lưu bản đồ giao diện",
  "ban_do.nhap": "Nhập bản đồ giao diện",
  "ban_do.sua_nhap": "Sửa bản nháp bản đồ",
  "ban_do.chon": "Chọn phiên bản thao tác",
  "ban_do.phat_hanh": "Phát hành bản đồ giao diện",
  "ban_do.tam_ngung": "Tạm ngưng thao tác",
  "ban_do.ap_dung": "Áp dụng bản đồ cho kịch bản",
  "ban_do.ap_dung_loi": "Áp dụng bản đồ lỗi",
  "ban_do.de_xuat": "Bot đề xuất bản đồ",
  "ban_do.bo_de_xuat": "Bỏ đề xuất bản đồ",
  "ban_do.dong_bo": "Đồng bộ bản đồ",
  "ban_do.khao_sat_gui": "Bot gửi khảo sát giao diện",
  "ban_do.tu_choi": "Từ chối yêu cầu bản đồ",
  "system.start": "Máy chủ khởi động",
  // đợt B3: mã ghép bằng `${loai}.lich_tao` (chuoi-kich-ban.ts) — audit() dựng mã động nên test quét literal không thấy
  "kich_ban.lich_tao": "Đặt hẹn giờ kịch bản",
  "chuoi.lich_tao": "Đặt hẹn giờ chuỗi",
};

/** Tên tiếng Việt của một mã hành động; mã lạ → giữ nguyên mã (không đoán). */
export function tenHanhDong(ma: string): string {
  return TEN_HANH_DONG[ma] ?? ma;
}

/** Mã hành động khớp chữ người dùng gõ ở ô lọc: gõ đúng tên tiếng Việt (không phân biệt hoa thường) → mã; còn lại giữ nguyên (gõ mã). */
export function maTuTen(chu: string): string {
  const s = chu.trim();
  if (!s) return "";
  const thap = s.toLocaleLowerCase("vi");
  for (const [ma, ten] of Object.entries(TEN_HANH_DONG)) if (ten.toLocaleLowerCase("vi") === thap) return ma;
  return s;
}

const NHAN_KHOA: Record<string, string> = {
  jobId: "Lệnh", jobIds: "Các lệnh", prevJobId: "Lệnh trước",
  botId: "Bot", bot: "Bot", bots: "Các bot", boQua: "Bỏ qua", botName: "Tên bot",
  kichBan: "Kịch bản", kichBanId: "Kịch bản", bundleName: "Kịch bản", bundleThich: "Kịch bản thích", bundleTraLoi: "Kịch bản trả lời", bundleBinhLuan: "Kịch bản bình luận",
  name: "Tên", ten: "Tên", username: "Tài khoản", role: "Vai trò", disabled: "Khoá",
  fromOwnerId: "Từ tài khoản", toOwnerId: "Sang tài khoản", toUsername: "Sang tài khoản",
  tz: "Múi giờ", url: "Địa chỉ", reason: "Lý do", loi: "Lỗi", ly_do: "Lý do",
  lyDo: "Lý do", giay: "Số giây", soChuot: "Lần chuột", soCuon: "Lần cuộn", soPhim: "Lần bấm phím", soGo: "Lần gõ chữ", kyTuGo: "Số ký tự đã gõ", fps: "Khung/giây",
  enabled: "Bật", mode: "Chế độ", version: "Phiên bản", phienBan: "Phiên bản", soBuoc: "Số bước",
  recipients: "Người nhận", tatCa: "Tất cả Boss", images: "Ảnh", title: "Tiêu đề", level: "Mức",
  places: "Số nơi", nicks: "Các nick", traLoi: "Số nick trả lời", thich: "Số nick thích", chu: "Chữ bình luận",
  everyMin: "Quét mỗi (phút)", withinDays: "Trong (ngày)", maxPerBotDay: "Tối đa/bot/ngày", maxPlaces: "Tối đa nơi",
  tu: "Từ", sang: "Sang", nhan: "Trạng thái", date: "Ngày", type: "Loại", created: "Tạo mới",
  limit: "Hạn mức", used: "Đã dùng", deXuat: "Đề xuất", nenTang: "Mạng", mau: "Mẫu",
  soNickMin: "Số nick ít nhất", soNickMax: "Số nick nhiều nhất", soTraLoi: "Số nick trả lời", gianCachMinPhut: "Giãn cách ít nhất (phút)", gianCachMaxPhut: "Giãn cách nhiều nhất (phút)",
  tuDuyet: "Tự gửi không duyệt", maxMoiBotNgay: "Tối đa lượt/nick/ngày", soLanGoi: "Số lần gọi AI",
  baseUrl: "Địa chỉ API", modelTeach: "Mô hình pha học", modelContent: "Mô hình bước nội dung", perBotPerHour: "Hạn mức gọi AI/bot/giờ", keyMask: "Khoá",
};
/** Trường chỉ là mã kỹ thuật, người đọc không cần. */
const AN_KHOA = new Set(["hash", "noticeId", "hashTep", "runKey", "doDai"]);

const GIA_TRI: Record<string, string> = { "Asia/Ho_Chi_Minh": "giờ Việt Nam", live: "chạy thật", draft: "chạy thử", dry: "chạy khô", boss: "Boss", super: "Super Boss", nhap: "Nháp", chay_thu: "Chạy thử", hoan_thien: "Hoàn thiện" };

export type TenMa = Record<string, { loai: string; ten: string }>;

/** Mọi chuỗi có thể là mã cần tra tên trong một dòng nhật ký (đối tượng + giá trị chuỗi / mảng chuỗi ở cấp đầu của chi tiết). */
export function maCanTra(target: string | null, json: unknown): string[] {
  const out = new Set<string>();
  const them = (v: unknown) => { if (typeof v === "string" && v && v.length <= 200 && !/\s/.test(v)) out.add(v); };
  them(target);
  if (json && typeof json === "object" && !Array.isArray(json)) {
    for (const [k, v] of Object.entries(json as Record<string, unknown>)) {
      if (AN_KHOA.has(k)) continue;
      if (Array.isArray(v)) v.forEach(them); else them(v);
    }
  }
  return [...out];
}

function giaTri(v: unknown, ten: TenMa): string {
  if (typeof v === "boolean") return v ? "có" : "không";
  if (typeof v === "string") return ten[v]?.ten ?? GIA_TRI[v] ?? v;
  if (typeof v === "number") return String(v);
  if (Array.isArray(v)) return v.length ? v.map((x) => giaTri(x, ten)).join(", ") : "(không)";
  if (v === null) return "(trống)";
  return JSON.stringify(v);
}

/** Chi tiết dễ đọc: "Nhãn: giá trị · …" — mã đổi ra tên, trường kỹ thuật ẩn, chuỗi giữ NGUYÊN ký tự (giao diện dựng bằng textContent). */
export function chiTietDeDoc(json: unknown, ten: TenMa = {}): string {
  if (json === null || json === undefined) return "";
  if (typeof json !== "object" || Array.isArray(json)) return giaTri(json, ten);
  return Object.entries(json as Record<string, unknown>)
    .filter(([k, v]) => v !== undefined && !AN_KHOA.has(k))
    .map(([k, v]) => `${NHAN_KHOA[k] ?? k}: ${giaTri(v, ten)}`)
    .join(" · ");
}

/** Đối tượng dễ đọc: mã → "Kịch bản “Tên”" / "Bot “Tên”"…; không tra được → giữ mã. */
export function doiTuongDeDoc(target: string | null, ten: TenMa = {}): string {
  if (!target) return "";
  const t = ten[target];
  if (!t) return target;
  const loai = t.loai === "kich_ban" ? "Kịch bản" : t.loai === "bot" ? "Bot" : t.loai === "tai_khoan" ? "Tài khoản" : t.loai === "lenh" ? "Lệnh" : "";
  return loai ? `${loai} “${t.ten}”` : t.ten;
}
